export function hasUsableExpiry(expiresAt) {
    if (!expiresAt)
        return false;
    const time = Date.parse(expiresAt);
    if (!Number.isFinite(time))
        return false;
    return Date.now() <= time - 30_000;
}
export function withScopedWidgetSession(value, client, chatbot) {
    if (!value?.widgetSession) {
        return value;
    }
    return {
        ...value,
        widgetSessionClient: client,
        widgetSessionChatbot: chatbot,
    };
}
export function getScopedWidgetSession(value, client, chatbot, settings) {
    const token = value?.widgetSession;
    if (!token || !hasUsableExpiry(value?.widgetSessionExpiresAtUtc)) {
        return "";
    }
    const cachedClient = value?.widgetSessionClient;
    const cachedChatbot = value?.widgetSessionChatbot;
    if (cachedClient || cachedChatbot) {
        return cachedClient === client && cachedChatbot === chatbot
            ? String(token)
            : "";
    }
    return settings?.client === client && settings?.chatbot === chatbot
        ? String(token)
        : "";
}
export function redactWidgetSessionDebugPayload(value) {
    if (!value || typeof value !== "object") {
        return value;
    }
    const clone = { ...value };
    if ("widgetSession" in clone) {
        clone.widgetSession = "[redacted]";
    }
    if ("widgetSessionExpiresAtUtc" in clone) {
        clone.widgetSessionExpiresAtUtc = "[redacted]";
    }
    return clone;
}
